module.exports = __webpack_public_path__ + "img/undeads-ad.e880ea95.png";